<template>
  <layout-quarter bg="/images/photo-8.jpg">
    <h1 class="heading h2 t-inverse t-center">
      Please select your price range
    </h1>

    <div class="button-group">
      <button-select @click.native="selectedPrice = price" :isActive="price.Id === selectedPrice.Id" v-for="price in priceRange" :key="price.Id">{{ price.Bracket }}</button-select>
    </div>

    <router-link class="button" to="/properties" :disabled="!Object.keys(selectedPrice).length">Next</router-link>
    <a class="button button--link" @click="$router.back()">Back</a>
  </layout-quarter>
</template>

<style scoped lang="scss">
  
</style>

<script>
  import { mapState } from 'vuex';
  import LayoutQuarter from '@/layouts/Quarter';
  import ButtonSelect from '@/components/ButtonSelect'

  export default {
    name: 'PriceRange',

    components: {
      LayoutQuarter,
      ButtonSelect
    },

    computed: {
      ...mapState([
        'priceRange'
      ]),

      selectedPrice: {
        get () {
          return this.$store.state.filters.priceRange;
        },

        set (value) {
          this.$store.commit('updatePriceRangeFilter', value)
        }
      }
    }
  };
</script>